export default __webpack_public_path__ + "static/media/ICON9.3d79fa1d.svg";